// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:720px){.SnackbarWrapper div.notificationSnackbarStyle.snackbar[data-v-b28bbaae]{max-width:unset}}", ""]);
// Exports
module.exports = exports;
